const API_BASE = (import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:5001').replace(/\/+$/, '');

const ABSOLUTE = /^(https?:|data:|blob:)/i;

export function resolveAssetUrl<T extends string | null | undefined>(url: T): T {
  if (!url) return url;
  if (ABSOLUTE.test(url)) return url;
  return `${API_BASE}${url.startsWith('/') ? '' : '/'}${url}` as T;
}
